import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Alert from "../../../Common/Alert";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";

import useAlertFromLocation from "../../../../hooks/useAlertFromLocation";
import useDeleteData from "../../../../hooks/useDeleteData";
import ReactDataTable from "../../../Common/ReactDataTable";

const List = () => {
  const [receiveData, setReceiveData] = useState([]);

  const [loading, setLoading] = useState(false);

  const formatTime = (time) => {
    if (!time) return "";

    const [hourStr, minuteStr] = time.split(":");
    let hour = parseInt(hourStr);
    const minute = parseInt(minuteStr);
    const ampm = hour >= 12 ? "pm" : "am";
    hour = hour % 12 || 12;

    return `${hour}.${minute.toString().padStart(2, "0")} ${ampm}`;
  };


  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await Http.get("/shift");
      setReceiveData(res.data.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  // to fetch data from the server
  useEffect(() => {
    fetchData();
  }, []);

  // to delete data call
  const deleteData = useDeleteData(fetchData);
  // to show alert message
  const alert = useAlertFromLocation();

  // columns for the datatable
  const cols = [
    { field: "name", header: "Name" },
    {
      header: "Start Time",
      field: (rowData) => formatTime(rowData.start_time),
    },
    {
      header: "End Time",
      field: (rowData) => formatTime(rowData.end_time),
    },
    {
      header: "Buffer Time",
      field: (rowData) => formatTime(rowData.buffer_time),
    },
  ];


  // action buttons for the datatable
  // const actionTemplate = (rowData, deleteData) => {
  //   return (
  //     <div className="text-xs text-nowrap">
  //       <Link
  //         to={{
  //           pathname: "/edit-shift/" + rowData.id,
  //           state: { id: rowData.id },
  //         }}
  //         className="btn btn-primary btn-sm"
  //         title="Edit"
  //       >
  //         <i className="fa fa-pencil" aria-hidden="true"></i>
  //       </Link>
  //       <button className="btn btn-danger btn-sm ms-1" onClick={() => deleteData(rowData.id, "shift", "Shift")} title="Delete">
  //         <i className="fa fa-trash"></i>
  //       </button>
  //     </div>
  //   );
  // };

  return (
    <div>
      <IsLogin></IsLogin>
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All Shifts</h5>
            {/* <Link to="/create-Shift" className="btn btn-primary">
              <i className="fa fa-plus-square mg-r-6"></i>Shift
            </Link> */}
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />
            <div className="card pd-20 pd-sm-40">
              <div className="row">
                <ReactDataTable cols={cols} receiveData={receiveData} isLoading={loading} deleteData={deleteData} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default List;
